document.addEventListener("DOMContentLoaded", () => {

    // Mobile Footer Accordion

    const accordionButtons = document.querySelectorAll(".footer-accordion-btn");

    accordionButtons.forEach((button) => {

        button.addEventListener("click", () => {

            const item = button.parentElement;

            const isActive = item.classList.contains("active");

            // Close all
            document.querySelectorAll(".footer-accordion-item").forEach((accordion) => {
                accordion.classList.remove("active");
            });

            // Open clicked one
            if (!isActive) {
                item.classList.add("active");
            }

        });

    });

});